import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../utils/UtilsUrl";
class SocieteService {
  addSocieteSeuil(model) {
    return api.post(`/retail/SocieteRestApi/addSocieteSeuil`, model);
  }

  blockSociete(idUser, idSociete) {
    return api.get("/retail/SocieteRestApi/blockSociete/" + idUser + "/" + idSociete);
  }
  addSociete(societe) {
    return api.post(UtilsUrl.societeURL() + "/addSociete", societe);
  }

  updateSociete(societe) {
    return api.post(UtilsUrl.societeURL() + "/updateSociete", societe);
  }

  getSocietesClients = (typeSociete, typeClient, isActive, isDeleted) => {
    let idUser = currentUserId();
    return api.get(
      `/retail/SocieteRestApi/allSocieteTypeClient/${typeSociete}/${typeClient}/${idUser}/${isActive}/${isDeleted}`
    );
  };
  getAllSuppliers = () => {
    let idUser = currentUserId();
    return api.get(
      `/retail/SocieteRestApi/allSocieteTypeClient/${"CLIENT"}/${"FOURNISSEUR"}/${idUser}/${1}/${0}`
    );
  };
  getFinacialYearsAndMonthsFromSocieteCreationDate = () => {
    let idUser = currentUserId();
    return api.get(
      `/retail/SocieteRestApi/getFinacialYearsAndMonthsFromSocieteCreationDate/${idUser}`
    );
  };

  // getSocietesClients(typeSociete, typeClient, isActive, isDeleted) {
  //   let idUser = currentUserId();

  //   return api.get(
  //     UtilsUrl.societeURL() +
  //       "/getListSociete/" +
  //       idUser +
  //       "/" +
  //       typeSociete +
  //       "/" +
  //       typeClient +
  //       "/" +
  //       isActive +
  //       "/" +
  //       isDeleted
  //   );
  // }
  getSocieteById(idSociete) {
    return api.get(UtilsUrl.soci + "/getSocieteById/" + idSociete);
  }
  getSocieteByIdUser() {
    let idUser = currentUserId();
    return api.get(UtilsUrl.societeURL() + "/getSocieteByIdUser/" + idUser);
  }

  allSocieteTypeClient(typeSociete, typeClient, isActive, isDeleted) {
    let idUser = currentUserId();
    return api.get(
      UtilsUrl.societeURL() +
      "/allSocieteTypeClient/" +
      typeSociete +
      "/" +
      typeClient +
      "/" +
      idUser +
      "/" +
      isActive +
      "/" +
      isDeleted
    );
  }
  testSocieteClient(idSociete, typeClient) {
    let idUser = currentUserId();
    return api.get(
      UtilsUrl.societeURL() +
      "/testSocieteClient/" +
      idSociete +
      "/" +
      typeClient +
      "/" +
      idUser
    );
  }

  changerTypeClientSociete(idSociete, typeClient) {
    return api.get(
      UtilsUrl.societeURL() +
      "/changerTypeClientSociete/" +
      idSociete +
      "/" +
      typeClient
    );
  }

  supprimer(idSociete) {
    return api.get(UtilsUrl.societeURL() + "/supprimerSociete/" + idSociete);
  }
  getAllGroupe () {
    return api.get( `/sales/societe/groupe/Allselect/${currentUserId()}`)
  };

}
export default new SocieteService();
export const uploadExcelFile=(data)=> {
  return api.post(`/retail/SocieteRestApi/addSocieteExcel/${currentUserId()}`, data);
}